<template>
  <div class="page_body">
    <div style="margin-bottom: 20px; font-weight: 800">
          <span
            ><el-checkbox v-model="checkedAll" @change="changeAllChecked()"
              >全选</el-checkbox
            ></span
          >
        </div>
    <div v-for="(item, index) in viewArr" :key="index" class="row">
      <p style="margin-bottom: 20px; font-weight: 800">{{ item.name }}</p>
      <template>
        <div style="margin-top: 20px">
          <div style="margin-top: 10px" class="row_child">
            <el-checkbox
              v-for="(child_item, child_index) in item.children"
              :key="child_index"
              v-model="child_item.check"
              :label="child_item.name"
              @change="checkBoxChange()"
            ></el-checkbox>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "phone",
  props: ["pageInfo", "permission", "type"],
  data() {
    return {
      listArr: [
        {
          name: "登录权限",
          key: "A",
        },
        {
          name: "管理入口",
          key: "B",
        },
        {
          name: "数据查看",
          key: "C",
        },
        {
          name: "工单入口",
          key: "D",
        },
      ],
      viewArr: [],
      checkedAll: false,
    };
  },
  created() {
    this.getAllCheck()
    console.log("phone")
    console.log(this.permission);
  },
  watch: {
    type: {
      handler() {
        this.getNewArrList();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    getNewArrList() {
      this.pageInfo.forEach((item) => {
        item.check = false;
        let has_id = this.permission.find(
          (permission_item) => Number(permission_item) === item.id
        );
        if(has_id) {
          item.check = true
        }
        let names = this.listArr.find((key) => key.key === item.sort_sequence);
        let obj = {
          name: names.name,
          key: names.key,
          children: [],
        };
        let has = this.viewArr.findIndex((value) => value.name === names.name);
        if (has > -1) {
          let child_has = this.viewArr[has].children.find(
            (has_item) => has_item.id === item.id
          );
          if (!child_has) {
            this.viewArr[has].children.push(item);
          }
        } else {
          obj.children.push(item);
          this.viewArr.push(obj);
        }
      });
      this.getAllCheckType();
    },
    getAllCheckType() {
      let arr = [];
      this.viewArr.forEach(item => {
          item.children.forEach(child_item => {
              if (child_item.check) {
                  arr.push(child_item.id)
              }
          })
      })
      this.checkedAll = arr.length === this.pageInfo.length
    },
    changeAllChecked() {
      this.checkedAll = !!this.checkedAll;
      console.log(this.checkedAll);
      this.viewArr.forEach((item) => {
        console.log(item);
        if(item) {
          item.children.forEach((child_item) => {
            child_item.check = this.checkedAll
          })
        }
      });
    },
    checkBoxChange() {
       this.$forceUpdate()
       this.getAllCheckType()
    },
    getAllCheck() {
      let arr = [];
      this.viewArr.forEach(item => {
          item.children.forEach(child_item => {
              if (child_item.check) {
                  arr.push(child_item.id)
              }
          })
      })
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.page_body {
  width: 100%;
  .row {
    margin-bottom: 20px;
    .row_child {
      .el-checkbox {
        display: inline-block;
        margin-left: 0;
        width: 25%;
      }
    }
  }
}
</style>
